import { UntypedFormGroup } from '@angular/forms'

export function confirmMatchingFormFields(leftField: string, rightField: string) {
  return (formGroup: UntypedFormGroup) => {
    if (formGroup.value[leftField] !== formGroup.value[rightField]) {
      return { mismatchedFields: [leftField, rightField] }
    }
    return null
  }
}
